import { login, logout, getUserInfo, getMenuList,loginByPhone } from "@/api/user";
import { setToken, getToken } from "@/libs/util";
import { Store } from "vuex";

export default {
  state: {
    userName: "",
    userId: "",
    avatorImgPath: "",
    token: getToken(),
    access: "",
    menuList: [],
    projectlist:[],
    user: null
  },
  getters: {
    getUser: (state, getters, rootState) => { return rootState.user; }
  },
  mutations: {
    setAvator(state, avatorPath) {
      state.avatorImgPath = avatorPath;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setAccess(state, access) {
      state.access = access;
    },
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    setMenuList(state, menuList) {
      state.menuList = menuList;
    },
    setUser(state, user) {
      state.userId = user.userId;
      state.username = user.userName;
      state.user = user;
    }
  },
  actions: {
    // 登录
    handleLogin({ commit }, data) {
      // userName = userName.trim()
      return new Promise((resolve, reject) => {
        login(data)
          .then(res => {
            const resData = res.data;
            if (resData.code === 0) {
              commit("setUser", resData.user);
              commit("setToken", resData.token);
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleL({ commit }, data) {
      // userName = userName.trim()
      return new Promise((resolve, reject) => {
        loginByPhone(data)
          .then(res => {
            const resData = res.data;
            if (resData.code === 0) {
              commit("setUser", resData.user);
              commit("setToken", resData.token);
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getMenuList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getMenuList(data).then(res => {       
            const resData = res.data;
            commit("setMenuList", resData.menuList);
            resolve(res);          
        });
      });
    },
    /*
    handleLogin ({ commit }, {userName, password}) {
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          userName,
          password
        }).then(res => {
          const data = res.data
          commit('setToken', data.token)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    */
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            // commit("setToken", "");
            localStorage.setItem('token',"")
            commit("setAccess", []);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        // 这里调用了 src/api/user 中的 getUserInfo
        getUserInfo(state.token)
          .then(res => {
            let data = {
              user_id: "1",
              name: "super_admin",
              access: ["super_admin", "admin"],
              token: "super_admin",
              avator:
                "https://avatars0.githubusercontent.com/u/20942571?s=460&v=4"
            };
            // const data = res.data
            commit("setAvator", data.avator);
            commit("setUserName", data.user_name);
            commit("setUserId", data.user_id);
            commit("setAccess", data.access);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sysQueryUserListString({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysQueryUserListString(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sysQueryUserList({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysQueryUserList(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sysDeleteUserById({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysDeleteUserById(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sysUpdateUserById({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysUpdateUserById(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sysNewUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysNewUser(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
